import ActiveSubscription from "types/ActiveSubscription";
import { UserType } from "types/Users";

export function canMutatePaymentSources(subscription: ActiveSubscription | null | undefined): boolean {
  if (!subscription) return false;
  return subscription.billingProvider !== "stripe"
    || subscription.capabilities.canWriteStripe === true;
}

export function canEditPaymentSource(subscription: ActiveSubscription | null | undefined): boolean {
  return subscription?.billingProvider === "chargebee";
}

export function canManageCoupons(subscription: ActiveSubscription | null | undefined): boolean {
  if (!subscription?.capabilities?.coupons) return false;
  return subscription.billingProvider !== "stripe"
    || subscription.capabilities.canWriteStripe === true;
}

export function shouldAwaitStripeProvisioning(
  user: Pick<UserType, "apiKey" | "billingProvider" | "planSlug"> | null | undefined
): boolean {
  return Boolean(
    user?.apiKey
    && user.billingProvider === "stripe"
    && (!user.planSlug || user.planSlug === "free")
  );
}
